import { useQuery } from '@apollo/client'
import cn from 'classnames'
import moment from 'moment'
import Image from 'next/image'
import { useState } from 'react'
import { TailSpin } from 'react-loading-icons'
import LogoLightSVG from 'src/assets/light_bg_logo.svg'
import {
  DownloadMaterialFilesDocument,
  IContentDataDownloadMaterialFragment,
  useDownloadContentMutation,
} from 'src/graphql/generated/hooks'
import { useAuthenticated } from 'src/hooks/useAuthenticated'

interface Props {
  contentId?: string | null
  downloadMaterial: IContentDataDownloadMaterialFragment
  onDisabledDownloadClick: () => void
  className?: string
  isContentPremium?: boolean
  isInvited?: boolean
  vendorSelfContent?: boolean
  isFreeArticle?: boolean | null
}

export const MaterialSection: React.FC<Props> = ({
  contentId,
  className,
  downloadMaterial,
  isContentPremium,
  onDisabledDownloadClick,
  isInvited,
  vendorSelfContent,
  isFreeArticle,
}) => {
  const { isPremium } = useAuthenticated()
  const lastUpdated = moment.utc(downloadMaterial?.lastUpdated)
  // eslint-disable-next-line no-console
  console.log('lastUpdated', lastUpdated)
  // eslint-disable-next-line no-console
  console.log('lastUpdatedWithDateObject', new Date(downloadMaterial?.lastUpdated))
  const [loading, setLoading] = useState(false)

  const { refetch } = useQuery(DownloadMaterialFilesDocument, {
    variables: {
      id: contentId || '',
    },
    skip: true,
  })

  const [downloadContent] = useDownloadContentMutation()

  const handleDownloadFiles = async () => {
    setLoading(true)
    await refetch()
      .then((data) => {
        window.open(data.data?.downloadMaterialFile?.url, '_blank')
        downloadContent({ variables: { content_id: contentId || '' } })
      })
      .finally(() => {
        setLoading(false)
      })
  }
  // eslint-disable-next-line no-console
  console.log('--------', isContentPremium)

  return (
    <div
      className={cn(
        'w-full h-full shadow-2xl rounded-lg px-[2.4rem] pt-[36.6px] pb-[1.4rem] border-[1px] border-[#e8e8e8] text-[.85rem] flex flex-col justify-between',
        className,
      )}
    >
      <div className="mb-[25px]">
        <span className="font-bold font-secondary text-[16px] text-dark leading-[25px]">
          {downloadMaterial.files?.data?.attributes?.name}
        </span>
      </div>
      <div className="divide-x h-[1px] bg-porcelain"></div>
      <div className="flex w-full">
        <span className="text-[15px] leading-[45px] font-secondary text-[#858585] mr-auto">FORMAT</span>
        <span className="font-bold text-[15px] font-secondary leading-[45px] ml-auto">{downloadMaterial.format}</span>
      </div>
      <div className="divide-x h-[1px] bg-porcelain"></div>
      <div className="flex w-full">
        <span className="font-light font-secondary leading-[45px] text-[#858585] mr-auto">LAST UPDATED</span>
        <span className="font-bold text-[15px] font-secondary leading-[45px] ml-auto">
          {lastUpdated.format('MM.DD.YY')}
        </span>
      </div>
      <div className="divide-x h-[1px] bg-porcelain"></div>
      <div className="w-full place-content-center px-auto mt-[.4rem] mb-[1rem]">
        {(isPremium || isInvited || vendorSelfContent || isFreeArticle) &&
          downloadMaterial.files?.data?.attributes?.name &&
          !loading && (
            <button
              onClick={handleDownloadFiles}
              className="text-white font-secondary font-bold text-center rounded-[22.5px] px-[25px] bg-navy w-full text-[14px] leading-[20px] h-[50px] mt-[5px]"
              style={{ fontWeight: 'bold', fontSize: '16px', fontFamily: 'karla', borderRadius: '25px' }}
            >
              {downloadMaterial.downloadButtonName}
            </button>
          )}
        {loading && (
          <div className="w-full flex items-center justify-center my-[20px]">
            <TailSpin stroke="#011D58" height="2em" /> <div className="pl-3"> Requesting download...</div>
          </div>
        )}
        {!isPremium && !isInvited && !vendorSelfContent && !isFreeArticle && (
          <button
            className="text-white font-secondary font-bold text-center rounded-[22.5px] px-[25px] bg-navy w-full text-[14px] leading-[20px] h-[50px] mt-[5px]"
            style={{ fontWeight: 'bold', fontSize: '16px', fontFamily: 'karla', borderRadius: '25px' }}
            onClick={onDisabledDownloadClick}
          >
            {downloadMaterial.downloadButtonName}
          </button>
        )}
      </div>
      <div className="w-full flex justify-center my-[10px]">
        <Image src={LogoLightSVG} className="w-[150px] h-[25.5px]" width={150} height={25.5} alt="" />
      </div>
    </div>
  )
}
